import { createContext, useContext } from 'react';

export interface SchedulingUnit {
  id: string;
  displayName: string;
}

/// As unidades que a pessoa alcança e a da sessão (ADR 0039). A composição fornece; a agenda só lê.
/// Sem provedor, ou com uma unidade só, nada de unidade aparece na tela.
export interface SchedulingUnits {
  units: readonly SchedulingUnit[];
  activeBusinessUnitId: string | null;
  /// A empresa contratou as comissões: a ficha do profissional mostra os campos (ADR 0082).
  commissionsEnabled?: boolean | undefined;
  /// Registrar vale na ficha do profissional (ADR 0082, decisão 24).
  canRegisterAdvances?: boolean | undefined;
  today?: string | undefined;
}

const context = createContext<SchedulingUnits>({ units: [], activeBusinessUnitId: null });

export const SchedulingUnitsProvider = context.Provider;

export function useSchedulingUnits(): SchedulingUnits {
  return useContext(context);
}
